import { Injectable } from '@angular/core';
import {
    DateRange,
    mutateState,
    Notice,
    NoticesService,
    patchableState,
    setState,
    StateUpdateCommand
} from '@flyfreely-portal-ui/flyfreely';
import { EMPTY, expand, map, Subject, takeUntil } from 'rxjs';

export interface SimplifiedLotamDetails {
    lotamId: number;
    dateRange: DateRange;
    name: string;
}

@Injectable()
export class MissionNoticesDataService {
    private organisationId: number;

    private ngUnsubscribe$ = new Subject<void>();

    private lotamsSource = new Subject<StateUpdateCommand<Notice[]>>();
    lotams$ = patchableState(this.lotamsSource, [] as Notice[]);

    constructor(private noticesService: NoticesService) {}

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
        this.lotamsSource.complete();
    }

    resetNotices() {
        this.lotamsSource.next(setState([]));
    }

    refreshNotices(dateRange?: DateRange, organisationId?: number) {
        this.organisationId = organisationId;
        if (this.organisationId == null) {
            return;
        }

        this.resetNotices();

        this.noticesService
            .findNotices(
                this.organisationId,
                {
                    page: 0,
                    pageSize: 50
                },
                dateRange
            )
            .pipe(
                expand(response => {
                    const pagination = response.pagination;
                    const pages = Math.ceil(
                        response.count / pagination.pageSize
                    );
                    return pagination.page < pages
                        ? this.noticesService.findNotices(
                              this.organisationId,
                              {
                                  page: pagination.page + 1,
                                  pageSize: pagination.pageSize
                              },
                              dateRange
                          )
                        : EMPTY;
                }),
                map(notices =>
                    notices.results.filter(
                        n => n.location != null && n.location.length > 0
                    )
                ),
                takeUntil(this.ngUnsubscribe$)
            )
            .subscribe(notices =>
                this.lotamsSource.next(
                    mutateState(existing => [...existing, ...notices])
                )
            );
    }
}
